/**
 * <p-iww-carousel> — Mobile-Swipe-Karussell der Section „Icons mit Wellen".
 * Ersetzt Hyper-Swiper (slidesPerView 2, slidesPerGroup 2, Punkte-Pagination)
 * durch natives Scroll-Snap; JS hält nur die Punkte synchron und macht sie klickbar.
 */
if (!customElements.get('p-iww-carousel')) {
  class PIwwCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-iww-track]');
      this.dots = [...this.querySelectorAll('[data-iww-dot]')];
      if (!this.track || this.dots.length === 0) return;
      this.onScroll = () => this.update();
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));
      this.update();
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.onScroll);
    }

    get pageWidth() {
      const slides = this.track.children;
      if (slides.length < 3) return this.track.clientWidth;
      return slides[2].offsetLeft - slides[0].offsetLeft;
    }

    goTo(index) {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.track.scrollTo({ left: Math.min(index * this.pageWidth, max), behavior: 'smooth' });
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const left = this.track.scrollLeft;
      let index = Math.round(left / this.pageWidth);
      if (max > 0 && left >= max - 2) index = this.dots.length - 1;
      index = Math.max(0, Math.min(index, this.dots.length - 1));
      this.dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
  }

  customElements.define('p-iww-carousel', PIwwCarousel);
}
